"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.onPending = function (type, delimiter) {
    if (delimiter === void 0) { delimiter = '_'; }
    return "" + type + delimiter + "PENDING";
};
exports.onFulfilled = function (type, delimiter) {
    if (delimiter === void 0) { delimiter = '_'; }
    return "" + type + delimiter + "FULFILLED";
};
exports.onRejected = function (type, delimiter) {
    if (delimiter === void 0) { delimiter = '_'; }
    return "" + type + delimiter + "REJECTED";
};
/**
 * Standard action creator factory.
 * @param type Action type.
 * @example
 * const addTodo = createAction('TODO_ADD', (name) => ({ name }));
 */
function createAction(type, payloadCreator, metadataCreator) {
    return Object.assign(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (tslib_1.__assign({ type: type }, (payloadCreator && { payload: payloadCreator.apply(void 0, args) }), (metadataCreator && { meta: metadataCreator.apply(void 0, args) })));
    }, { toString: function () { return type; } });
}
exports.createAction = createAction;
/**
 * Asynchronous action creator factory.
 * @param type Action type.
 * @example
 * const getTodos = createAsyncAction('TODOS_GET', () => fetch('https://todos.com/todos'));
 */
function createAsyncAction(type, payloadCreator, metadataCreator, options) {
    if (options === void 0) { options = {}; }
    return Object.assign(createAction(type, payloadCreator, metadataCreator), {
        toString: function () {
            throw new Error("Async action " + type + " must be handled with pending, fulfilled or rejected");
        },
    }, {
        pending: createAction(exports.onPending(type, options.promiseTypeDelimiter)),
        fulfilled: createAction(exports.onFulfilled(type, options.promiseTypeDelimiter), function (payload) { return payload; }),
        rejected: createAction(exports.onRejected(type, options.promiseTypeDelimiter), function (payload) { return payload; }),
    });
}
exports.createAsyncAction = createAsyncAction;
//# sourceMappingURL=actions.js.map